import { Link } from 'react-router-dom';

const navLinks = [
  { href: '/', label: 'Startseite' },
  { href: '/leistungen', label: 'Leistungen' },
  { href: '/leistungsgebiete', label: 'Leistungsgebiete' },
  { href: '/projekte', label: 'Projekte' },
  { href: '/ueber-uns', label: 'Über uns' },
  { href: '/jobs', label: 'Jobs' },
  { href: '/kontakt', label: 'Kontakt' },
];

const services = [
  'Sanierung & Renovierung',
  'Trockenbau',
  'Fassade & Außenwände',
  'Bodenbeläge',
  'Garten- & Landschaftsbau',
  'Bauzeichnungen für Garten & Landschaften',
];

export default function Footer() {
  return (
    <footer className="bg-[#0a2240] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
          {/* Brand */}
          <div className="space-y-3 sm:space-y-4">
            <img
              src="https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/c496e7b7b0d35cec41af6fd81216106e.png"
              alt="IGM Facility Service"
              className="h-8 sm:h-10 w-auto object-contain object-left"
            />
            <p className="text-sm text-white/70 leading-relaxed">
              Ihr zuverlässiger Partner für professionellen Neubau, Sanierung und Renovierung in
              Ratingen und ganz NRW.
            </p>
            <div className="flex items-center space-x-3">
              <a
                href="https://www.facebook.com/igmfacilityservice/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-11 h-11 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg" />
              </a>
              <a
                href="https://www.instagram.com/igmfacilityservice/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-11 h-11 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg" />
              </a>
              <a
                href="#"
                className="w-11 h-11 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Navigation</h3>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-white/70 hover:text-white transition-colors inline-block py-1"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Bauleistungen</h3>
            <ul className="space-y-2">
              {services.map((s) => (
                <li key={s} className="text-sm text-white/70 py-1">
                  {s}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-lg text-white/70" />
                </div>
                <span className="text-sm text-white/70">Industriestr. 37, 40878 Ratingen</span>
              </li>
              <li className="flex items-center space-x-3 min-h-[44px]">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-lg text-white/70" />
                </div>
                <a
                  href="tel:+492102739807"
                  className="text-sm text-white/70 hover:text-white transition-colors"
                >
                  02102 7398070
                </a>
              </li>
              <li className="flex items-center space-x-3 min-h-[44px]">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-lg text-white/70" />
                </div>
                <a
                  href="mailto:kontakt@igmfacilityservice.de"
                  className="text-sm text-white/70 hover:text-white transition-colors break-all"
                >
                  kontakt@igmfacilityservice.de
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-lg text-white/70" />
                </div>
                <span className="text-sm text-white/70">
                  Mo–Fr: 10:00–15:00
                  <br />
                  Sa: 12:00–15:00
                  <br />
                  So: geschlossen
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 sm:mt-12 pt-6 sm:pt-8 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-sm text-white/50 text-center md:text-left">
            © 2021 IGM Facility Service. Alle Rechte vorbehalten.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
            <Link
              to="/impressum"
              className="text-sm text-white/50 hover:text-white transition-colors min-h-[44px] flex items-center"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="text-sm text-white/50 hover:text-white transition-colors min-h-[44px] flex items-center"
            >
              Datenschutz
            </Link>
            <Link
              to="/agb"
              className="text-sm text-white/50 hover:text-white transition-colors min-h-[44px] flex items-center"
            >
              AGB
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
